import { IUrlData } from './index'

interface IParams {
  [name: string]: string | string[]
}

export interface MakeUrlArgs {
  urlData?: IUrlData
  get?: IParams
  refTag?: string
  isShortUrl?: boolean
}

const mergeQueryParams = (existing: IParams, fresh: IParams = {}) =>
  Object.assign({}, existing, fresh)

const FOGG_REGION_PREFIX = new RegExp('/region/(na|eu|fe|local)')

export const pathPrefix = (
  { originalURI }: IUrlData
) => {
  const match = originalURI && originalURI.match(FOGG_REGION_PREFIX)
  return (match && match[0]) || ''
}

const encodedParam = (key: string, value: string) =>
  `${encodeURIComponent(key)}=${encodeURIComponent(value)}`

const avoidDoubleSlash = (path: string) => path.replace(/^\//, '')

export const makeUrl = (
  path: string,
  { urlData, get, refTag }: MakeUrlArgs
) => {
  if (!urlData) {
    return ''
  }

  const prefix = pathPrefix(urlData)
  const contextUrlParams = urlData.parameters || {}
  const paramsToPersist = Object.keys(contextUrlParams).reduce(
    (params, key) => {
      params[key] = contextUrlParams[key].value
      return params
    },
    {} as IParams
  )

  const mergedParams = mergeQueryParams(paramsToPersist, get)
  const paramsString = Object.keys(mergedParams)
    .reduce((acc: string[], key: string) => {
      const value = mergedParams[key]
      if (Array.isArray(value)) {
        const encodedParams = value.map(v => encodedParam(key, v))
        acc.push(...encodedParams)
      } else {
        acc.push(encodedParam(key, value))
      }
      return acc
    }, [])
    .join('&')
  const actualParams = paramsString ? `?${paramsString}` : ''
  const actualRefTag = refTag ? `/ref=${refTag}` : ''

  return `${prefix}/${avoidDoubleSlash(path)}${actualRefTag}${actualParams}`
}
